import React, { useEffect } from 'react'

const Scrolling = () => {
  useEffect(() => {
    var didScroll = true; 

    function hasScrolled() {
      var st = window.pageYOffset;
      var header = document.querySelector('.masthead');
      if (st > 10){
        header.classList.add('scrolling');
      } else {
        header.classList.remove('scrolling');
      }
    } 
  
    document.addEventListener("scroll", (event) => {
      didScroll = true;
    }); 

    setInterval(function () {
      if (didScroll) {
          hasScrolled();
          didScroll = false;
      }
    }, 300);
  }, [])
  return (
  <></>
  )
}

export default Scrolling
